"use client";

import React from "react";
import { Button } from "./ui/button";
import { Link, useRouter } from "@/i18n/routing";
import { useTranslations } from "next-intl";
import { useUserStore } from "@/store/store";
import { isAuthenticated } from "@/service/auth-service";
import UserMenu from "./user-menu";

const AccessButton = () => {
  const t = useTranslations("general");
  const router = useRouter();
  const { isAuthenticated: isAuth } = useUserStore();

  const handleClick = (e: React.MouseEvent) => {
    // Check if user is authenticated using the service
    if (isAuthenticated()) {
      // If authenticated, redirect to home or dashboard
      e.preventDefault();
      router.push("/");
    }
    // Otherwise, let the Link handle navigation to login
  };

  // If authenticated, show user menu with profile
  if (isAuthenticated()) {
    return <UserMenu />;
  }

  return (
    <Button
      asChild
      className="bg-gradient-to-t from-primary to-second-primary rounded-full text-base md:text-xl  py-2  h-fit px-8 text-primary-foreground hover:text-primary-foreground/80 transition z-10"
      onClick={handleClick}
    >
      <Link href="/auth/login">{t("sign_in") || "Sign In"}</Link>
    </Button>
  );
};

export default AccessButton;
